import { useContext } from 'react';
import { ActionLoaderContext, ActionLoaderState } from 'components/Loaders';

export function useFormActionLoader(): ActionLoaderState {
  return useContext(ActionLoaderContext);
}
